'use client';

import React from 'react';
import { Search, MoreVertical, Edit, Users, UserCircle2, Bell } from 'lucide-react';

interface Conversation {
  id: string;
  name: string;
  initials: string;
  avatarGradient: string;
  lastMessage: string;
  timestamp: string;
  unread?: number;
  isOnline?: boolean;
  isMuted?: boolean;
  isGroup?: boolean;
}

const CONVERSATIONS: Conversation[] = [
  {
    id: '1',
    name: 'Ate Boni',
    initials: 'AB',
    avatarGradient: 'linear-gradient(135deg, #287FD8 0%, #6650D8 100%)',
    lastMessage: 'nakita ko na, salamat! 🎉',
    timestamp: '11:38 AM',
    isOnline: true,
  },
  {
    id: '2',
    name: 'Design Team',
    initials: 'DT',
    avatarGradient: 'linear-gradient(135deg, #22C55E 0%, #16A34A 100%)',
    lastMessage: 'You: Check the latest mockups 🔥',
    timestamp: '10:15 AM',
    unread: 3,
    isGroup: true,
  },
  {
    id: '3',
    name: 'Marco Reyes',
    initials: 'MR',
    avatarGradient: 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)',
    lastMessage: 'Sige, bukas na lang tayo mag-meet',
    timestamp: 'Yesterday',
    isOnline: true,
  },
  {
    id: '4',
    name: 'Jess & Friends',
    initials: 'JF',
    avatarGradient: 'linear-gradient(135deg, #EC4899 0%, #BE185D 100%)',
    lastMessage: 'Jess: Haha okay lang yan! 😂',
    timestamp: 'Yesterday',
    unread: 12,
    isGroup: true,
  },
  {
    id: '5',
    name: 'Kuya Dan',
    initials: 'KD',
    avatarGradient: 'linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)',
    lastMessage: 'Padala mo na yung file mamaya',
    timestamp: 'Mon',
    isMuted: true,
  },
  {
    id: '6',
    name: 'Ana Santos',
    initials: 'AS',
    avatarGradient: 'linear-gradient(135deg, #06B6D4 0%, #0284C7 100%)',
    lastMessage: 'Kumain ka na ba? 😄',
    timestamp: 'Mon',
    isOnline: true,
    unread: 1,
  },
  {
    id: '7',
    name: 'Work Updates',
    initials: 'WU',
    avatarGradient: 'linear-gradient(135deg, #F97316 0%, #EA580C 100%)',
    lastMessage: 'You: Done na ✅ check mo na lang',
    timestamp: 'Sun',
    isGroup: true,
  },
  {
    id: '8',
    name: 'Lola Nena',
    initials: 'LN',
    avatarGradient: 'linear-gradient(135deg, #10B981 0%, #059669 100%)',
    lastMessage: 'Ingat ka palagi ha anak 🙏',
    timestamp: 'Sat',
  },
  {
    id: '9',
    name: 'Barkada GC',
    initials: 'BG',
    avatarGradient: 'linear-gradient(135deg, #EF4444 0%, #DC2626 100%)',
    lastMessage: 'Carlo: Saan tayo mamaya?',
    timestamp: 'Fri',
    unread: 27,
    isGroup: true,
  },
  {
    id: '10',
    name: 'Paolo Cruz',
    initials: 'PC',
    avatarGradient: 'linear-gradient(135deg, #6366F1 0%, #4F46E5 100%)',
    lastMessage: 'Salamat sa tulong kahapon!',
    timestamp: 'Thu',
  },
];

interface ChatListProps {
  onOpenChat: (chatId: string) => void;
  onOpenSearch?: () => void;
  onNewConversation?: () => void;
  onOpenContacts?: () => void;
  onOpenMyProfile?: () => void;
  onOpenSettings?: () => void;
  onOpenNotifications?: () => void;
}

export default function ChatList({ onOpenChat, onOpenSearch, onNewConversation, onOpenContacts, onOpenMyProfile, onOpenSettings, onOpenNotifications }: ChatListProps) {
  return (
    <div
      style={{
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        background: '#101C29',
      }}
    >
      {/* Header */}
      <header
        className="flex items-center justify-between px-3 sm:px-4 flex-shrink-0"
        style={{
          height: '56px',
          background: 'rgba(16,28,41,0.97)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(255,255,255,0.06)',
        }}
      >
        <h1 className="text-[20px] sm:text-[22px] font-bold text-white tracking-tight">Chats</h1>
        <div className="flex items-center gap-0.5">
          <button
            onClick={onOpenSearch}
            className="flex items-center justify-center w-[38px] h-[38px] rounded-full text-white/70 hover:bg-white/10 hover:text-white transition-all duration-150"
            aria-label="Search"
          >
            <Search size={19} />
          </button>
          <button
            onClick={onOpenNotifications}
            className="flex items-center justify-center w-[38px] h-[38px] rounded-full text-white/70 hover:bg-white/10 hover:text-white transition-all duration-150"
            aria-label="Notifications"
          >
            <Bell size={19} />
          </button>
          <button
            onClick={onNewConversation}
            className="flex items-center justify-center w-[38px] h-[38px] rounded-full text-white/70 hover:bg-white/10 hover:text-white transition-all duration-150"
            aria-label="New chat"
          >
            <Edit size={19} />
          </button>
          <button
            onClick={onOpenContacts}
            className="flex items-center justify-center w-[38px] h-[38px] rounded-full text-white/70 hover:bg-white/10 hover:text-white transition-all duration-150"
            aria-label="Contacts"
          >
            <Users size={19} />
          </button>
          <button
            onClick={onOpenMyProfile}
            className="flex items-center justify-center w-[38px] h-[38px] rounded-full text-white/70 hover:bg-white/10 hover:text-white transition-all duration-150"
            aria-label="My Profile"
          >
            <UserCircle2 size={19} />
          </button>
          <button
            className="flex items-center justify-center w-[38px] h-[38px] rounded-full text-white/70 hover:bg-white/10 hover:text-white transition-all duration-150"
            aria-label="More options"
            onClick={onOpenSettings}
          >
            <MoreVertical size={19} />
          </button>
        </div>
      </header>

      {/* Search bar — tappable shortcut to full search screen */}
      <div className="px-4 py-3 flex-shrink-0" style={{ background: '#101C29' }}>
        <button
          onClick={onOpenSearch}
          className="w-full flex items-center gap-2.5 px-3.5 rounded-2xl text-left"
          style={{ background: 'rgba(255,255,255,0.07)', height: '40px' }}
          aria-label="Open search"
        >
          <Search size={16} className="text-white/40 flex-shrink-0" />
          <span className="text-[14px]" style={{ color: 'rgba(255,255,255,0.35)' }}>
            Search conversations…
          </span>
        </button>
      </div>

      {/* Conversation list */}
      <div className="flex-1 overflow-y-auto" style={{ overscrollBehavior: 'contain', scrollbarWidth: 'none' }}>
        {CONVERSATIONS.map((conv, idx) => (
          <ConversationRow
            key={conv.id}
            conv={conv}
            isLast={idx === CONVERSATIONS.length - 1}
            onClick={() => onOpenChat(conv.id)}
          />
        ))}
      </div>
    </div>
  );
}

function ConversationRow({
  conv,
  isLast,
  onClick,
}: {
  conv: Conversation;
  isLast: boolean;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className="w-full flex items-center gap-3 px-4 py-3 text-left transition-colors duration-100 active:scale-[0.99]"
      style={{
        borderBottom: isLast ? 'none' : '1px solid rgba(255,255,255,0.04)',
        background: 'transparent',
      }}
      onMouseEnter={e => {
        (e.currentTarget as HTMLButtonElement).style.background = 'rgba(255,255,255,0.04)';
      }}
      onMouseLeave={e => {
        (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
      }}
    >
      {/* Avatar */}
      <div className="relative flex-shrink-0">
        <div
          className="w-[52px] h-[52px] rounded-full flex items-center justify-center text-white font-bold text-[16px]"
          style={{ background: conv.avatarGradient }}
          aria-label={`${conv.name} avatar`}
        >
          {conv.initials}
        </div>
        {conv.isOnline && (
          <span
            className="absolute bottom-[1px] right-[1px] w-[13px] h-[13px] bg-green-400 rounded-full border-2"
            style={{ borderColor: '#101C29' }}
            aria-label="Online"
          />
        )}
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2 mb-[3px]">
          <span
            className="text-[15px] font-semibold truncate"
            style={{ color: conv.unread ? '#FFFFFF' : 'rgba(255,255,255,0.92)' }}
          >
            {conv.name}
          </span>
          <span
            className="text-[12px] flex-shrink-0"
            style={{ color: conv.unread ? '#4A9EE8' : 'rgba(255,255,255,0.38)' }}
          >
            {conv.timestamp}
          </span>
        </div>
        <div className="flex items-center justify-between gap-2">
          <span
            className="text-[13px] truncate leading-snug"
            style={{ color: conv.unread ? 'rgba(255,255,255,0.72)' : 'rgba(255,255,255,0.42)' }}
          >
            {conv.lastMessage}
          </span>
          {conv.unread ? (
            <span
              className="flex-shrink-0 flex items-center justify-center rounded-full text-white font-semibold"
              style={{
                background: '#4A9EE8',
                minWidth: conv.unread > 9 ? '20px' : '18px',
                height: '18px',
                fontSize: '11px',
                padding: '0 4px',
              }}
            >
              {conv.unread > 99 ? '99+' : conv.unread}
            </span>
          ) : null}
        </div>
      </div>
    </button>
  );
}
